// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Latvia from '../_raw/flag/icon_flag_latvia.png';

export default () => <img src={Latvia} alt="Latvia" />;
